export const REVYRE = {
  COLLECT_IQ: {
    WORKFLOW_TYPES: ['batch', 'case', 'loan'],
    DOMAIN_TYPES: ['activity', 'workflow', 'approval', 'payment'],
    CREATE_SCENARIO_BLOCKED_ENTITIES: ['ccase', 'loan', 'payment'],
    RESTRICT_HEADER_BUTTONS: ['loan'],
    DETAILS_PAGE_QUICK_ACTIONS_HIDDEN_RULES: {
      nonWorkflow: {
        hiddenStatuses: ['COMPLETED', 'PAYMENT_COMPLETED', 'CANCELLED'],
      },
      workflow: {
        hiddenByInputKey: 'suspended',
      },
    },
    DETAILS_PAGE_CUSTOM_REFFERED_ENTITIES: ['payment'],
    STATUS_ERROR_CODE_WITH_DESCRIPTION: [50008],
  },
};

export const STATE_ID = 'stateId';
export const DISPOSITION_GROUP = 'outcomeGroup';
